var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11885",
    "data-name": "Group 11885",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.314,
    height: 13.392,
    viewBox: "0 0 17.314 13.392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17022",
    "data-name": "Rectangle 17022",
    width: 17.314,
    height: 13.392,
    fill: "#6676aa"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11884",
    "data-name": "Group 11884",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37945",
    "data-name": "Path 37945",
    d: "M6.366,3.169c0,.757,0,1.514,0,2.271a.776.776,0,0,1-.852.859Q3.228,6.3.944,6.3a.791.791,0,0,1-.866-.877q0-2.271,0-4.542A.8.8,0,0,1,.948,0Q3.219,0,5.49,0a.789.789,0,0,1,.875.869c0,.766,0,1.532,0,2.3M1.65,4.712H4.762a.279.279,0,0,0,.027-.07c0-.962,0-1.925.009-2.887,0-.177-.108-.176-.232-.176-.891,0-1.781.007-2.672,0-.216,0-.25.086-.248.273.008.792,0,1.583,0,2.375v.49",
    transform: "translate(-0.073 0)",
    fill: "#ee7d11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37946",
    "data-name": "Path 37946",
    d: "M150.3,190.752c-1.261,0-2.522,0-3.783,0a.8.8,0,0,1-.892-.681.771.771,0,0,1,.623-.874,1.153,1.153,0,0,1,.214-.022h7.728a.818.818,0,0,1,.723.346.777.777,0,0,1-.482,1.206,1.944,1.944,0,0,1-.376.027q-1.878,0-3.756,0",
    transform: "translate(-137.745 -178.941)",
    fill: "#ee7d11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37947",
    "data-name": "Path 37947",
    d: "M150.3,45.337c-1.306,0-2.612,0-3.918,0a.77.77,0,0,1-.782-.709.781.781,0,0,1,.584-.832,1.082,1.082,0,0,1,.267-.027q3.864,0,7.728,0a.8.8,0,0,1,.844.646.777.777,0,0,1-.516.876,1.278,1.278,0,0,1-.4.048q-1.905.005-3.81,0",
    transform: "translate(-137.722 -41.398)",
    fill: "#ee7d11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37948",
    "data-name": "Path 37948",
    d: "M2.43,162.394q1.084-1.132,2.169-2.263c.137-.143.276-.285.425-.416a.785.785,0,0,1,1.1.04.762.762,0,0,1,0,1.076q-1.614,1.617-3.249,3.212a.75.75,0,0,1-1.113-.028q-.78-.787-1.537-1.6a.764.764,0,0,1,.025-1.094.774.774,0,0,1,1.1,0c.171.159.325.337.492.5s.339.32.509.48l.089.09",
    transform: "translate(0 -150.885)",
    fill: "#ee7d11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.a5a3d8f3fc3ad0e47b7455e180488cf6.svg";
export { ForwardRef as ReactComponent };